import { Controller } from 'stimulus'
import {} from 'jQuery.print'

export default class BackupCodesController extends Controller {
  static targets = ['codes', 'downloadUrl', 'copyBtn']

  copy() {
    const clipboard = new ClipboardJS(this.codesTarget)
    clipboard.on('success', () => {
      this.showPopup()
      this.enableNext()
    })
    return false
  }

  download() {
    window.open(this.downloadUrlTarget.value, '_blank')
    this.enableNext()
    return false
  }

  print(event) {
    const printable = event.target.dataset.printable
    if (printable)
      $(printable).print({
        globalStyles: true,
        mediaPrint: true,
        iframe: true,
        noPrintSelector: '.no-print',
      })
    else
      window.print()
    this.enableNext()
    return false
  }

  enableNext() {
    $('#bt-next').removeClass('disabled')
  }

  showPopup() {
    let popupSettings = {
      on: 'click',
      delay: {
        show:  50,
        hide: 200
      },
      exclusive: true,
      position: 'top right',
      variation: 'inverted',
      context: $(this.copyBtnTarget),
    }

    this.destroyPopup();

    $(this.copyBtnTarget).popup(popupSettings).popup('show')

    this.hidePopup();
  }

  hidePopup() {
    this.timeout = setTimeout(() => {
      this.destroyPopup();
    }, 750)
  }

  destroyPopup() {
    if ( $(this.copyBtnTarget).find('.ui.popup').length > 0) {
      $(this.copyBtnTarget).find('.ui.popup').remove()
      clearTimeout(this.timeout)
    }
  }
}
